import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConnectionService } from '../connection-service';
import { Broadcaster } from 'src/components/broadcaster';
import { AppConfig } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class FieldVisibilityService {
  private hiddenFields: Set<string> = new Set();
  private hiddenFieldsSubject = new BehaviorSubject<Set<string>>(new Set());

  constructor(
    private readonly connectionService: ConnectionService,
    private readonly broadcasterService: Broadcaster,
    private readonly appConfig: AppConfig
  ) {}

  setHiddenFields(fields: string[]): void {
    this.hiddenFields = new Set(fields);
    this.hiddenFieldsSubject.next(this.hiddenFields);
  }

  isFieldHidden(fieldName: string): boolean {
    return this.hiddenFields.has(fieldName);
  }

  getHiddenFieldsObservable() {
    return this.hiddenFieldsSubject.asObservable();
  }

  async loadCatalogFieldsToHide(): Promise<void> {
    try {
      const hiddenFields = await this.connectionService.fetchCatlogFieldsToHide();
      this.setHiddenFields(hiddenFields);
    } catch (error) {
      this.broadcasterService.broadcast('NOTIFY', { message: error.message, type: this.appConfig.Shared.Toast.Type.ERROR });
      this.setHiddenFields([]);
    }
  }
}
